import {IAlertInstanceController, MK_ALERT_INSTANCE} from "./IAlertInstanceController";
import {AbstractController} from "../../../controllers/AbstractController";
import {inject, Injectable, signal} from "@angular/core";
import {Helper} from "../../../helpers/Helper";
import {CustomDatesService} from "../../../services/custom-dates.service";
import {AppEventBus} from "../../../event-buses/app.event-bus";
import {AppEventName} from "../../../event-buses/AppEventName";
import {AppEvent} from "../../../event-buses/AppEvent";
import {AlertRuleHistoryRepository} from "../../../repositories/alert-rule-history.repository";
import {AlertService} from "../../../services/alert-service";
import {AlertViewModalView} from "../../alert-view-modal/_views/alert-view-modal.view";
import {DialogService} from "primeng/dynamicdialog";

@Injectable()
export class StandardAlertInstanceController extends AbstractController implements IAlertInstanceController {

  private readonly appEventBus = inject(AppEventBus);

  private readonly dialogService = inject(DialogService);
  private readonly customDateService = inject(CustomDatesService);
  private readonly alertService = inject(AlertService);

  private readonly alertRuleHistoryRepository = inject(AlertRuleHistoryRepository);

  constructor() {
    super();

    this.addModel(MK_ALERT_INSTANCE, {
      alertInstance$: signal(null),
      duration$: signal(''),
      mode$: signal(null),
    });

    this.sub(this.appEventBus.subscribe(AppEventName.NotificationListToggled, (event) => {
      this.onNotificationListToggled(event);
    }));
  }

  handleInit(eventData: any): void {
    if(Helper.isValid(eventData['alertInstance'])) {
      const model = this.getModel(MK_ALERT_INSTANCE);
      model.alertInstance$.set(eventData['alertInstance']);
      model.mode$.set(eventData['mode']);

      const alertTimestamp = model.alertInstance$()!.timestamp;
      const duration = (new Date().getTime() - alertTimestamp) / 1000;

      model.duration$.set(this.customDateService.humaniseSecondsWithTranslation(duration));
    }
  }

  handleAlertSelection(eventData: any): void {
    const model = this.getModel(MK_ALERT_INSTANCE);
    const alertInstance = model.alertInstance$();

    if(alertInstance) {
      this.alertRuleHistoryRepository.getAlertInstance(alertInstance.id).subscribe({
        next: (data) => {
          if(data) {
            const alertData = this.alertService.createAlertDataFromResponse(data);

            this.alertService.populateSourceInfoForAlert(alertData).subscribe((result) => {
              const cloneAlert = Helper.clone(alertData);
              AlertViewModalView.show(this.dialogService, cloneAlert);
            });

            this.appEventBus.dispatch(new AppEvent(AppEventName.AlertSelection, {alert: alertInstance}));
          }
          else {
            this.errorToast(`Alert not found`);
          }
        },
        error: (error) => {
          this.errorToast(`Alert not found`);
        }
      });
    }
  }

  onNotificationListToggled(event: AppEvent): void {
    const model = this.getModel(MK_ALERT_INSTANCE);

    if(model.alertInstance$()) {
      const alertTimestamp = model.alertInstance$()!.timestamp;
      const duration = (new Date().getTime() - alertTimestamp) / 1000;

      model.duration$.set(this.customDateService.humaniseSecondsWithTranslation(duration));
    }
  }
}
